import { Box, Flex, Image } from '@chakra-ui/react'
import FlagAm from 'shared/images/flag-am.svg'
import FlagRu from 'shared/images/flag-ru.svg'

const TYPE_FLAG = {
  RUSSIA: FlagRu,
  ARMENIA: FlagAm,
}

export const CountryWidget = ({ lang, children, ...props }) => {
  return (
    <Flex align="center" {...props}>
      <Image boxSize="20px" minWidth="20px" src={TYPE_FLAG[lang]} mr="10px" />
      <Box>{children}</Box>
    </Flex>
  )
}
